var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"col-sm-4 col-md-7"},[_c('p',{staticClass:"copyright"},[_vm._v(" © Copyright Rastreator.com "+_vm._s(_vm.year)+"."),_c('br'),_vm._v(" Todos los Derechos Reservados ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }